import TaskStatus from './TaskStatus.constants';

export default [
	TaskStatus.PAUSED,
	TaskStatus.MANAGING,
	TaskStatus.WAITING_FOR_AGENT,
	TaskStatus.ASSIGNED_TO_PARTNER,
	TaskStatus.ASSIGNED_TO_TEAM,
];
